<template>
    <div class="regionpick" @click.stop>
        <input type="text" class="input-text" v-model="simpleName" readonly placeholder="点击选择地区" @click="openCity();"/> 
        <div class="province" v-if="selectShow" ref="province" :style="right ? 'right:0' : 'left:0'">
            <div class="hd clearfix" v-show="levels == 2 || levels == 3">
                <a class="back fr" v-if="level > 1" href="javascript:void(0);" @click="cityBack();">返回</a>
                <span class="title" v-if="levels == '2'">{{provinceName}}/{{cityName}}</span>
                <span class="title" v-if="levels == '3'">{{provinceName}}/{{cityName}}/{{county}}</span>
            </div>
            <!-- 省份数据 -->
            <ul class="city-list clearfix" v-show="level === 1">
                <li v-for="(item,index) in provinceList" :key="index" @click="clickCityName(item.name,item.fullname,index);">{{item.name}}</li>
            </ul>
            <!-- 市数据 -->
            <ul class="city-list clearfix" v-show="level === 2">
                <li v-for="(item,index) in cityList" :key="index" @click="clickCityName(item.name,item.fullname,index);">{{item.name}}</li>
            </ul>
            <!-- 区县数据 -->
            <ul class="city-list clearfix" v-show="level === 3">
                <li v-for="(item,index) in countyList" :key="index" @click="clickCityName(item.name,item.fullname,index);">{{item.name}}</li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    name: "citys",
    props: {
        levels: {//控制层级
            type: String,
            default: '3',
        },
		type:{//type是2得时候显示只选省份按钮
			type: String,
			default: '1',
		}
    },
    data() {
        return {
            level:1,//选择省市区级别
            allArr:[],//所有数据
            provinceName:'选择省份',
            cityName:'选择城市',
            county:'选择区县',
            provinceList:[],//省份数据
            cityList:[],//城市数据
            countyList:[],//区县数据
            right:false,
            selectShow:false,
            backShow:false,
            fullsName:{
               province:'', 
               city:'', 
               county:'', 
            },//全称显示
            fullName:'',
            simpleName:'',//简称显示
        }
    },
    mounted() {
        document.addEventListener('click', this.closeCity);
        let that = this;
        that.$axios.get('/static/city.json').then((res) => {
            that.allArr = res.data;
        })
    },
    destroyed () {
        document.removeEventListener('click', this.closeCity)
    },
    created() {
		
    },
    methods: {
        //关闭
        closeCity () {
            this.resetText()
        },
        
        // 打开城市
        openCity () {
            let that = this;
            if(that.selectShow == true){
                that.selectShow = false;
                that.resetText(0);
                return;
            }else{
                that.selectShow = true;
                document.addEventListener('click',this.hideSel,true)
                that.provinceList = that.allArr.arrCity;
            }
            that.$nextTick(() =>{
                let left = that.$refs.province.getBoundingClientRect().left;
                let widowW = document.body.clientWidth;
                let width = that.$refs.province.offsetWidth;
                if(widowW - left < width){
                    that.right = true;
                }
            })
        },
        hideSel(e){
            if(!this.$el.contains(e.target)){
                this.resetText();
            }
            document.removeEventListener('click',this.hideSel,true)
        },
        //点击选项
        clickCityName (name,names,index) {
            let that = this;
            if(that.level === 1){//选择省份
                that.cityList = that.provinceList[index].sub;
                that.provinceName = name;
                if(that.cityList.length <= 0){
                    that.fullsName.province = name;
                    that.resetText(1);
                    return;
                }else{
                    that.fullsName.province = names;
                }
                if(that.levels == 1){
                    that.resetText(1);
                    return;
                }
            }else if(that.level === 2){//选择城市
                that.countyList = that.cityList[index].sub;
                that.cityName = name;
                if(!that.countyList || that.countyList.length <= 0){
                    that.fullsName.city = name;
                    that.resetText(1);
                    return;
                }else{
                    that.fullsName.city = names;
                }
                if(that.levels == 2){
                    that.resetText(1);
                    return;
                }
            }else if(that.level === 3){//选择区县
                that.county = name;
                that.fullsName.county = name;
                that.resetText(1);
                return;
            }
            that.level++;
        },
        // 重置
        resetText (type){
            if(type === 0){//打开城市
                this.fullName = '';
            }else if(type === 1){//选择结束
                // this.simpleName = '';
                if(this.cityName != '选择城市' && this.cityName != '全省' && this.cityName != '全市'){
                    if(this.county != '选择区县' && this.county != '全市'){
                        this.simpleName = this.provinceName + '-' + this.cityName + '-' + this.county;
                        this.fullName = this.fullsName.province + '-' + this.fullsName.city + '-' + this.fullsName.county;
                    }else{
                        this.simpleName = this.provinceName + '-' + this.cityName
                        this.fullName = this.fullsName.province + '-' + this.fullsName.city
                    }
                }else{
                    this.simpleName = this.provinceName;
                    this.fullName = this.fullsName.province;
                }
                this.callBack();
            }
            this.provinceName = '选择省份';
            this.cityName = '选择城市';
            this.county = '选择区县';
            this.selectShow = false;
            this.level = 1;
        },
        // 返回
        cityBack () {
            let that = this;
            that.level--;
            if(that.level === 2){
                this.cityName = '选择城市';
            }else if(that.level === 1){
                this.provinceName = '选择省份';
            }
        },
        callBack () {
            this.$emit('cityCallback',this.simpleName);
        }
	}
}
</script>
<style lang="" scope>
    .regionpick{display:inline-block;position:relative;}
    .regionpick:before{content:'';width:14px;height:14px;position:absolute;top:9px;right:9px;background:url(../../static/images/icons.png) no-repeat 0 -165px;}
    .regionpick .input-text{width:136px;height:32px;}
    .province{position:absolute;top:34px;width:462px;background:#fff;border:1px solid #ddd;z-index:9;box-shadow:0 0 15px rgba(0,0,0,.2);}
    .province .hd{padding:0 15px;line-height:32px;position:relative;border-bottom:1px solid #ddd}
    .province .hd .back{color:#31bcf6;}
    .province .hd .back + .back{margin-right:15px;}
    .province .city-list{padding:10px;}
    .province .city-list li{float:left;width:110px;padding:5px;line-height:24px;cursor:pointer;}
    .province .city-list li:hover{color:#0095eb;}
</style>



// WEBPACK FOOTER //
// src/components/city.vue